import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { useThemeTokens } from '@providers/themeTokenProvider';

export const SegmentedToggle = ({
  leftLabel,
  rightLabel,
  isRightActive,
  onToggle,
}: {
  leftLabel: string;
  rightLabel: string;
  isRightActive: boolean;
  onToggle: () => void;
}) => {
  const { sys } = useThemeTokens();
  const segments = [
    { label: leftLabel, active: !isRightActive },
    { label: rightLabel, active: isRightActive },
  ];
  return (
    <Box
      sx={{
        display: 'inline-flex',
        border: '1px solid',
        borderColor: sys.color.outlineVariant,
        borderRadius: '6px',
        overflow: 'hidden',
        userSelect: 'none',
      }}
    >
      {segments.map((seg, idx) => (
        <Box
          key={seg.label}
          onClick={onToggle}
          sx={{
            width: 32,
            height: 28,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            bgcolor: seg.active ? sys.color.primary : 'transparent',
            borderRight: idx === 0 ? '1px solid' : 'none',
            borderColor: sys.color.outlineVariant,
            transition: 'background 0.15s ease',
            '&:hover': {
              bgcolor: seg.active
                ? sys.color.primaryHover
                : sys.color.neutralHover,
            },
          }}
        >
          <Typography
            variant='labelSmall'
            sx={{
              fontWeight: 700,
              fontSize: '0.75rem',
              color: seg.active
                ? sys.color.onPrimary
                : sys.color.onSurfaceVariant,
            }}
          >
            {seg.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export const TogglePill = ({
  label,
  isActive,
  onToggle,
}: {
  label: string;
  isActive: boolean;
  onToggle: () => void;
}) => {
  const { sys } = useThemeTokens();
  return (
    <Box
      onClick={onToggle}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        border: '1px solid',
        borderColor: isActive ? sys.color.primary : sys.color.outlineVariant,
        borderRadius: '6px',
        px: 1.5,
        height: 28,
        bgcolor: isActive ? sys.color.primary : 'transparent',
        transition: 'all 0.15s ease',
        userSelect: 'none',
        '&:hover': {
          bgcolor: isActive ? sys.color.primaryHover : sys.color.neutralHover,
        },
      }}
    >
      <Typography
        variant='labelSmall'
        sx={{
          fontWeight: 600,
          fontSize: '0.7rem',
          color: isActive ? sys.color.onPrimary : sys.color.onSurfaceVariant,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
